import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useOrganizationCategoryUIContext } from "./OrganizationCategoryUIContext";
import { OrganizationCategoryFilter } from "./organization-category-table/organization-category-filter/OrganizationRegionalFilter";
import {
  fetchOrganizationCategorys,
  createOrganizationCategory,
  updateOrganizationCategory
} from "../../_redux/organization-category/organizationCategoryAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import OrganizationCategoryTable from "./organization-category-table/OrganizationCategoryTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { ConfirmationModal } from "../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { Collapse } from "react-bootstrap";
import { RoleChecker } from "../../../../RoleChecker";

export const OrganizationCategoryCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();

  const [openFilter, setOpenFilter] = useState(false);

  // * OrganizationCategory UI Context
  const organizationCategoryUIContext = useOrganizationCategoryUIContext();
  const organizationCategoryUIProps = useMemo(() => {
    return {
      queryParams: organizationCategoryUIContext.queryParams,
      setQueryParams: organizationCategoryUIContext.setQueryParams,
      openEditOrganizationCategoryPage:
        organizationCategoryUIContext.openEditOrganizationCategoryPage,
      newOrganizationCategoryButtonClick:
        organizationCategoryUIContext.newOrganizationCategoryButtonClick
    };
  }, [organizationCategoryUIContext]);

  // * Getting curret state of organizationCategory list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminOrganizationCategory,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke OrganizationCategory Action
    dispatch(
      fetchOrganizationCategorys(organizationCategoryUIProps.queryParams)
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationCategoryUIProps.queryParams, dispatch]);

  const allowCreate = RoleChecker("Create", "master_data_category");
  const allowEdit = RoleChecker("Edit", "master_data_category");

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* CREATE FOLDER MODAL */}
      <Card>
        <CardHeader title="Category">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
            {allowCreate && (
              <button
                type="button"
                className="btn mx-1 btn-primary"
                onClick={() => {
                  organizationCategoryUIProps.newOrganizationCategoryButtonClick();
                }}
              >
                Tambah Category
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div className="collapse-filter">
              <OrganizationCategoryFilter />
            </div>
          </Collapse>
          <OrganizationCategoryTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={organizationCategoryUIProps.queryParams}
            setQueryParams={organizationCategoryUIProps.setQueryParams}
            openEditOrganizationCategoryPage={
              organizationCategoryUIProps.openEditOrganizationCategoryPage
            }
            allowEdit={allowEdit}
          />
        </CardBody>
      </Card>
    </>
  );
};
